'use strict';

var moment = require('moment-timezone')
var _ = require('underscore');
var querystring = require('querystring');

var GOOGLE_URL = 'http://www.google.com/calendar/event?';
var OUTLOOK_URL = 'http://calendar.live.com/calendar/calendar.aspx?';
var YAHOO_URL = 'http://calendar.yahoo.com/?';

var DATE_FORMAT = 'YYYYMMDD[T]HHmmss[Z]';

function googleUrl(params) {
  return GOOGLE_URL + params;
}

function googleParams(evt) {
  var params = {
    action: 'TEMPLATE',
    dates: evt.start.format(DATE_FORMAT) + '/' + evt.end.format(DATE_FORMAT),
    text: evt.title,
    location: evt.location,
    details: evt.description,
  };

  return params;
}

function outlookUrl(params) {
  return OUTLOOK_URL + params;
}

function outlookParams(evt) {
  return {
    rru: 'addevent',
    dtstart: evt.start.format(DATE_FORMAT),
    dtend: evt.end.format(DATE_FORMAT),
    summary: evt.title,
    location: evt.location,
    description: evt.description,
  };
}

function yahooUrl(params) {
  return YAHOO_URL + params;
}

function yahooParams(evt) {
  return {
    v: 60,
    st: evt.start.format(DATE_FORMAT),
    title: evt.title,
    in_loc: evt.location,
    dur: moment.utc(evt.end.clone().diff(evt.start)).format('HHmm'),
    desc: evt.description,
  };
}

function normalizeEvent(evt) {
  evt.start = moment.tz(evt.start, evt.timezone).tz('UTC');
  evt.end = moment.tz(evt.end, evt.timezone).tz('UTC');
  return evt;
}

function dataUrl(data) {
  var query = '';

  if (window.location.search.indexOf('lang=')) {
    var regex = /\??lang=(\w+)/;
    var matches = window.location.search.match(regex);

    if (matches && matches.length >= 2) {
      query = '?lang=' + matches[1];
    }
  }

  return window.location.origin + '/appointments/ics/' + data.appointment_id + '/' + data.client_id + '/' + data.confirm_code + query;
}

export default {
  google: _.compose(googleUrl, querystring.stringify, googleParams, normalizeEvent),
  outlook: _.compose(outlookUrl, querystring.stringify, outlookParams, normalizeEvent),
  yahoo: _.compose(yahooUrl, querystring.stringify, yahooParams, normalizeEvent),
  ical: _.compose(dataUrl),
};
